export default class ChatBotConfigWhatsAppTemplateModel {
  constructor({
    id = 0,
    chatBotId = 0,
    nome = '',
    tipoId = 0,
    zenviaTemplateId = null,
    conteudo = '',
    ativo = true,
  } = {}) {
    this.id = id
    this.chatBotId = chatBotId
    this.nome = nome
    this.tipoId = tipoId
    this.zenviaTemplateId = zenviaTemplateId
    this.conteudo = conteudo
    this.ativo = ativo
  }
}
